import getFormControl from "./getFormControl";

const setInputValue = (id, value) => {
  getFormControl(id).val(value);
  console.log({id, value});
};

export default setInputValue;
